export default "__VITE_ASSET__da7awvKP__"